
export default function HeroSection() {
  return (
    <section className="relative bg-gradient-to-br from-blue-600 to-purple-600 text-white py-20">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20financial%20dashboard%20with%20charts%20and%20graphs%2C%20business%20analytics%20interface%2C%20pricing%20strategy%20visualization%2C%20professional%20financial%20planning%20workspace%2C%20clean%20minimal%20design&width=1920&height=800&seq=pricing-hero&orientation=landscape')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-purple-900/90"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
          Simple, Transparent Pricing
        </h1>
        <p className="text-xl sm:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed">
          Choose the perfect plan for your business. All packages include unlimited revisions and 30-day money-back guarantee.
        </p>
        <div className="flex flex-wrap justify-center gap-8">
          <div className="flex items-center">
            <i className="ri-shield-check-line text-3xl text-green-400 mr-3"></i>
            <span className="text-lg">30-Day Guarantee</span>
          </div>
          <div className="flex items-center">
            <i className="ri-refresh-line text-3xl text-yellow-400 mr-3"></i>
            <span className="text-lg">Unlimited Revisions</span>
          </div>
          <div className="flex items-center">
            <i className="ri-customer-service-2-line text-3xl text-purple-300 mr-3"></i>
            <span className="text-lg">24/7 Support</span>
          </div>
        </div>
      </div>
    </section>
  );
}